import { createBullet } from "../templates/slider-bullet";

import Glide from "@glidejs/glide";

export default function (target, options) {
    const sliders = document.querySelectorAll(`.js-${target}`);

    sliders.forEach(slider => {
        const sliderItems = slider.querySelector(`.js-${target}-items`);
        const sliderBullets = slider.querySelector(`.js-${target}-bullets`);

        if (sliderBullets) {
            const count = sliderItems.childElementCount;
            if (count > 1) {
                Array.from(Array(count).keys()).forEach(x => {
                    sliderBullets.append(createBullet(target, x));
                });
            } else {
                sliderBullets.innerHTML = null;
            }
        }

        new Glide(slider, options).mount();
    });
};